<template>
  <div data-testid="visit-medicaments">
    <div class="row">
      <div class="col-md-8">
        <div class="card-body">
          <list-prescription :do-update="reloadPrescription" v-on:updated="updatePrescriptionDone" :clientId="clientId" :visitId="visitId"></list-prescription>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card-body bg-danger-light" v-if="pharmAnamnesis || allergicAnamnesis">
          <template v-if="allergicAnamnesis">
            <span style="font-weight: bold;">{{ allergicAnamnesis.anamnesis_type.shortcode }} - {{ allergicAnamnesis.anamnesis_type.name }}</span><br>
            <div v-html="allergicAnamnesis.text"></div>
          </template>
          <template v-if="pharmAnamnesis">
            <span style="font-weight: bold;">{{ pharmAnamnesis.anamnesis_type.shortcode }} - {{ pharmAnamnesis.anamnesis_type.name }}</span><br>
            <div v-html="pharmAnamnesis.text"></div>
          </template>
        </div>
        <add-medicament :client-id="clientId" :visit-id="visitId" :visiv-on:update="updateMedicament" :copied-medicament="medicamentToCopy"></add-medicament>
      </div>
    </div>
    <div class="card-body bg-light">
      <list-previous-medicament v-on:copied="copyMedicament"></list-previous-medicament>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import ListMedicament from './ListMedicament.vue'
  import ListPrescription from '@/views/Prescribtion/ListPrescription.vue'
  import ListPreviousMedicament from './ListPreviousMedicament.vue'
  import AddMedicament from '@/views/Prescribtion/AddMedicament.vue'

  export default {
    data () {
      return {
        reloadMedicament: false,
        reloadPrescription: false,
        medicamentToCopy: false,
        // actual anamnesis
        actualClientAnamnesis: false,
        actualClientAnamnesisError: false,
        actualClientAnamnesisPending: false,
        actualClientAnamnesisDone: false,
        //
        pharmAnamnesis: false,
        allergicAnamnesis: false
      }
    },
    mixins: [apiMixin],
    methods: {
      updateMedicament () {
        this.reloadPrescription = true
      },
      updateMedicamentDone () {
        this.reloadMedicament = false
      },
      copyMedicament (medicament) {
        this.medicamentToCopy = medicament
      },
      updatePrescriptions () {
        this.reloadPrescription = true
        this.updateMedicament()
      },
      updatePrescriptionDone () {
        this.reloadPrescription = false
      }
    },
    computed: {
      visitId () {
        return this.$route.params.visitid
      },
      clientId () {
        return this.$route.params.clientid
      }
    },
    watch: {
      actualClientAnamnesis (val) {
        if (val) {
          this.pharmAnamnesis = false
          this.allergicAnamnesis = false
          val.forEach((element) => {
            if (element.anamnesis_type.id === 6 && element.text !== '') {
              this.pharmAnamnesis = element
            }
            if (element.anamnesis_type.id === 5 && element.text !== '') {
              this.allergicAnamnesis = element
            }
          })
        }
      }
    },
    mounted () {
      this.getActualClientAnamnesis(this.$route.params.clientid)
    },
    components: {
      ListMedicament,
      ListPrescription,
      ListPreviousMedicament,
      AddMedicament
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/VisitMedicament.vue?1814be12